<template>
    <section class="container">
        <section class="panel center-block">
            <div class="container-fluid">
                <h1>Êtes-vous prêt à relever ce défi?</h1>
                <div class="field">
                    <span class="error">* Identifiant obligatoire</span>
                    <input type="text" v-model="username" placeholder="Mon identifiant" />
                </div><!-- FIELD-->
                <div class="field mb-2">
                    <span class="error">* Code obligatoire</span>
                    <input type="text" v-model="password" placeholder="Mon code challenge" />
                </div><!-- FIELD-->
                <p><a href="javascript:void(0);" class="text-color" title="Code oublié ?" v-on:click="modalOpen_forgotten = ! modalOpen_forgotten">Code challenge oublié ?</a></p>
                <p class="error" v-html="message"></p>
                <div class="w-100 text-right">
                    <button class="btn btn-primary" v-on:click="GetToken"><i class="icon thumb-up-white"></i> C'est parti !</button>
                </div>
            </div>
        </section><!-- PANEL -->
        <span class="panel-bottom"></span>
        <section class="modal" v-bind:class="{ modalopen: modalOpen_forgotten }">
            <div class="modal-content bg-warning">
                <h3>Code Challenge oublié ?</h3>
                <p>Contacter notre support technique en écrivant à contact@fora.fr.</p>
                <div class="text-center">
                    <button class="btn btn-border-white" v-on:click="modalOpen_forgotten = ! modalOpen_forgotten">Fermer la fenêtre</button>
                </div>
            </div>
        </section><!-- MODAL-->
    </section><!-- CONTAINER FLUID-->
</template>
<script>


    import $ from 'jquery';
    import { Utility } from '../configs/configpaths';
    export default {
        data: function () {
            return {
                modalOpen_forgotten: false,
                username: "",
                password: "",
                message: ""

            };
        },
        mounted: function () {
            var _self = this;

            _self.$parent.GloablEvents();

            localStorage.removeItem("user")
            localStorage.removeItem("user-token");

            _self.AutoLogin();


    },
        methods: {
            AutoLogin: function () {
                var _self = this;
                var settings = {
                    "crossDomain": true,
                    "url": _self.BASE_URL + "api/Inscription/Token",
                    "data": {
                        "token": String(_self.$route.path).substr(6),

                    },
                    "method": "GET",

                };

                $.ajax(settings).done(function (response) {

                    if (!response) {
                        _self.$router.push('/');

                        return;
                    }
                    _self.username = response.Identifiant;
                    _self.password = response.Code;
                    _self.GetToken();

                });
            },
            Ask: function () {
                return window.Notification.requestPermission();
            },
           
            check: function () {
                if (!('serviceWorker' in navigator)) {
                    throw new Error('No Service Worker support!')
                }
                if (!('PushManager' in window)) {
                    throw new Error('No Push API Support!')
                }
            },
            registerServiceWorker: function () {
                return navigator.serviceWorker.register('/service.js'); //notice the file name

            },
            showLocalNotification: function (title, body, swRegistration) {
                const options = {
                    // body,
                    body: body,
                    icon: "https://i.ibb.co/Hrc8jhB/goweb.png"

                };
                swRegistration.showNotification(title, options);
            },
            RegisterDevice: function (id) {
                var _self = this;
                try {
                    $("#spinner").show();
                    Notification.requestPermission(function (permission) {
                        // If the user accepts, let's create a notification
                        if (permission === "granted") {
                            _self.registerServiceWorker().then(() => {
                                $("#spinner").hide();
                                var myWorker = new Worker('/service.js');
                                myWorker.postMessage(id);

                            });
                        }
                    });
                } catch (e) {
                    $("#spinner").hide();
                }
            },
            GetToken: function () {
                var _self = this;
                _self.message = "";
                var settings = {
                    "async": false,
                    "crossDomain": true,
                    "url": _self.BASE_URL + "token",
                    "method": "POST",
                    "data": "userName=" + _self.username + "&password=" + _self.password + "&grant_type=password"

                };

                $.ajax(settings).done(function (response) {

                    _self.$parent.$children[1].ShowLogOut = true;
                    _self.message = "";
                    Utility.SetToken(response.access_token);
                    $("#spinner").show();
                    _self.Redirect();

                }).fail(function (response) {
                    $("#spinner").hide();
                    try {
                        _self.message = response.responseJSON.error_description;
                    } catch (e) {
                        //test
                    }


                    Utility.SetToken(null);
                });
            },
            Redirect: function () {
                var _self = this;

                var settings = {
                    "async": false,
                    "crossDomain": true,
                    "url": _self.BASE_URL + "api/Question/Current",
                    "method": "GET",
                    "headers": {
                        'Authorization': 'Bearer ' + Utility.GetToken()
                    }
                };

                $.ajax(settings).done(function (response) {

                    Utility.SetCurrent(response);
                    try {
                        _self.$parent.$children[5].SetBackGround();
                    } catch (e) {
                        //CATCH
                    }

                    $("#liReglement").show();
                    _self.$parent.CreateStyle();
                    _self.RegisterDevice(response.Id);

                    if (response.Role === "TESTEUR") {
                        _self.$router.push('/ListeQuestions')
                    } else {
                        var id = parseInt(response.QuestionId);
                        var ch = parseInt(response.Challenge);
                        //console.dir(response);
                        if (response.ShowReglement !== true) {
                            _self.$router.push('/Reglement/' + ch);
                            return;
                        }
                        if (response.DejaJoue === true) {
                            _self.$router.push('/DejaJoue/' + id);
                            return;
                        }
                        if (response.TypeQuestion === "ChoixUnique") { _self.$router.push('/QuestionType2/' + id); }
                        if (response.TypeQuestion === "ChoixMultiple") { _self.$router.push('/QuestionType3/' + id); }
                        if (response.TypeQuestion === "Numerique") { _self.$router.push('/QuestionType1/' + id); }
                        //_self.$router.push('/ListeQuestions')
                    }
                }).fail(function () {

                })
            }


        }

    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
